export default "__VITE_ASSET__ByTUaVHg__"